module.exports = __webpack_public_path__ + "img/teaser_240x200_prefleurdelis.8516801b.jpg";